module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('div', {
    staticClass: "counter-parent"
  }, [_c('span', [_vm._v(_vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds))])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-container"
  }, [(_vm.finishedGame) ? _c('div', {
    staticClass: "win-lose-style you-win"
  }, [_vm._v("You Win")]) : _vm._e(), _vm._v(" "), (_vm.timeLeft === 0 && !_vm.finishedGame) ? _c('div', {
    staticClass: "win-lose-style you-lose"
  }, [_vm._v("You Lose")]) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    attrs: {
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight,
      "disabled": ""
    },
    on: {
      "mousedown": _vm.mousedown,
      "mouseup": _vm.mouseup,
      "mousemove": _vm.mousemove
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7b85d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 107
// module chunks = 1